// POST_SURVEY — Section 10.

import { useState } from 'react';
import AffectSurvey from '../components/AffectSurvey';
import StopButton from '../components/StopButton';
import ConfirmationModal from '../components/ConfirmationModal';
import { useSessionStore } from '../store/sessionStore';
import { useParticipantStore } from '../store/participantStore';

export default function PostSurveyScreen({ onContinue, onAbandon }) {
  const [valence, setValence] = useState(3);
  const [arousal, setArousal] = useState(3);
  const [confirmingStop, setConfirmingStop] = useState(false);
  const setAffectPost = useSessionStore((s) => s.setAffectPost);
  const abandon = useSessionStore((s) => s.abandon);
  const participantPatch = useParticipantStore((s) => s.patch);

  function handleContinue() {
    setAffectPost(valence, arousal);
    onContinue();
  }

  async function handleStop() {
    // Text + image audio are still only in sessionStore at this point —
    // discarding the store IS discarding them. Nothing uploads.
    abandon('post_survey');
    await participantPatch({ active_in_session: false, current_session_id: null });
    onAbandon();
  }

  return (
    <div className="screen">
      <h1 className="font-display text-2xl mb-6">Post-Session Check-in</h1>
      <AffectSurvey valence={valence} arousal={arousal} onValenceChange={setValence} onArousalChange={setArousal} />

      <div className="mt-auto pt-6">
        <button type="button" onClick={handleContinue} className="btn-primary">
          Continue
        </button>
        <StopButton onClick={() => setConfirmingStop(true)} />
      </div>

      <ConfirmationModal
        open={confirmingStop}
        title="Stop this session?"
        message="Nothing from this session will be saved."
        confirmLabel="Yes, stop"
        cancelLabel="No, keep going"
        danger
        onCancel={() => setConfirmingStop(false)}
        onConfirm={handleStop}
      />
    </div>
  );
}
